import App from '@/models/App'

export default class OrderingOrdererItemSubCategory extends App {
    static get entity() {
        return 'OrderingOrdererItemSubCategories'
    }

    static all() {
        return this.query().get()
    }

    static first() {
        return this.query().first()
    }

    static fields() {
        return {
            id: this.attr(''),
            orderingShipId: this.attr(''),
            orderingItemCategoryId: this.attr(''),
            name: this.attr(''),
            sort: this.attr(''),
            hasAlert: this.attr(false),
        }
    }

    static apiConfig = {
        actions: {
            find(orderingShipId, orderingItemCategoryId, orderingItemSubCategoryId) {
                return App.api().get(
                    `/ordering/orderer/${orderingShipId}/categories/${orderingItemCategoryId}/subCategories/${orderingItemSubCategoryId}`,
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        baseURL: App.apiURL(),
                    }
                )
            },
            fetch(orderingShipId, orderingItemCategoryId, params) {
                return this.get(
                    `/ordering/orderer/${orderingShipId}/categories/${orderingItemCategoryId}/subCategories`,
                    {
                        params: App.get(params),
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.apiURL(),
                    }
                )
            },
            create(orderingShipId, orderingItemCategoryId, params) {
                return this.post(
                    `/ordering/orderer/${orderingShipId}/categories/${orderingItemCategoryId}/subCategories`,
                    App.post(params),
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        baseURL: App.apiURL(),
                    }
                )
            },
            update(orderingShipId, orderingItemCategoryId, orderingItemSubCategoryId, params) {
                return this.patch(
                    `/ordering/orderer/${orderingShipId}/categories/${orderingItemCategoryId}/subCategories/${orderingItemSubCategoryId}`,
                    App.patch(params),
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        baseURL: App.apiURL(),
                    }
                )
            },
            sorting(orderingShipId, orderingItemCategoryId, params) {
                return this.patch(
                    `/ordering/orderer/${orderingShipId}/categories/${orderingItemCategoryId}/subCategories/sorting`,
                    params,
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        baseURL: App.apiURL(),
                    }
                )
            },
            destroy(orderingShipId, orderingItemCategoryId, orderingItemSubCategoryId) {
                return this.delete(
                    `/ordering/orderer/${orderingShipId}/categories/${orderingItemCategoryId}/subCategories/${orderingItemSubCategoryId}`,
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        delete: orderingItemCategoryId,
                        baseURL: App.apiURL(),
                    }
                )
            },
        },
    }
}
